export default __webpack_public_path__ + "871f34559c6ff46537c37386966713be.png";